import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { useStore } from '../../app/stores/store';
import DynamicTableComponentForMetaData from './DynamicTableComponentForMetaData';
import { v4 as uuid } from 'uuid';
import _ from 'lodash';
import agent from '../../app/api/agent';
import UnauthorizedMessage from '../UnauthorizedMessage';

function MetaDataReport2() {
  const {
    reportStore,
    userStore,
    dashboardStore,
    activityStore,
    commonStore,
    metaDataStore,
  } = useStore();
  const { userReadableDateFormatMetaData } = commonStore;
  const { DropdownParentAll, dropDowndata } = metaDataStore;
  const {
    loadReportPagination,
    metaDataPaginationAll,
    loadMetaDataStoredHeaders,
  } = reportStore;
  const [pageNumber, setPageNumber] = useState(
    dashboardStore.dashboard.setReportsPageNum,
  );
  const [currentTask, setCurrentTask] = useState<{
    value: string;
    list: {
      key: string;
      value: string;
      text: string;
    }[];
  }>({
    value: '',
    list: [],
  });
  const [currentSubTask, setCurrentSubTask] = useState<{
    value: string;
    list: {
      key: string;
      value: string;
      text: string;
    }[];
  }>({
    value: '',
    list: [],
  });

  let localStoreageItem: any = localStorage.getItem('ReportsTable');

  const getNewDetails = (pageNumber?: number) => {
    let titles = localStorage.getItem('ReportsTable')?.split(',') || [];
    titles.push('id');
    let searchData = Object.assign(
      {},
      dashboardStore.dashboard.searchfilterparams,
    );

    if (currentSubTask.value === '' && currentTask.value === '') {
      return;
    }

    if (currentSubTask.value === '' && currentTask.value) {
      delete searchData[`current_subtask`];
      searchData[`current_task`] = currentTask.value;
      reportStore.searchMetaDataReport(pageNumber || 1, searchData, titles);
      return;
    }

    searchData[`current_task`] = currentTask.value;
    searchData[`current_subtask`] = currentSubTask.value;

    reportStore.searchMetaDataReport(pageNumber || 1, searchData, titles);
  };

  useEffect(() => {
    (async () => {
      let result = await agent.ProdPlanning.listProductionType();
      if (result.data) {
        setCurrentTask({
          ...currentTask,
          list: result.data.map((d: { task: string }) => ({
            key: d.task,
            value: d.task,
            text: d.task,
          })),
        });
      }
    })();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    (async () => {
      let result = await agent.ProdPlanning.listProductionTask(
        currentTask.value,
      );
      if (result.data) {
        setCurrentSubTask({
          ...currentSubTask,
          list: result.data.map((d: { subtask: string }) => ({
            key: d.subtask,
            value: d.subtask,
            text: d.subtask,
          })),
        });
      }
    })();
    // eslint-disable-next-line
  }, [currentTask.value]);

  useEffect(() => {
    getNewDetails(dashboardStore.dashboard.setReportsPageNum);
    // eslint-disable-next-line
  }, [currentSubTask.value, currentTask.value]);

  useEffect(() => {
    dropDowndata('');
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    dashboardStore.dashboard.setTagTablePageNumber === 1 &&
      setPageNumber(dashboardStore.dashboard.setTagTablePageNumber);
  }, [dashboardStore.dashboard.setTagTablePageNumber]);

  useEffect(() => {
    dashboardStore.dashboard.setReportsPageNum === 1 &&
      setPageNumber(dashboardStore.dashboard.setReportsPageNum);
  }, [dashboardStore.dashboard.setReportsPageNum]);

  useEffect(() => {
    dashboardStore.updateCountOrderMenu(userStore.user!.id);
    // loadMetaDataHeaders();
    loadMetaDataStoredHeaders();

    if (localStoreageItem?.split(',')) {
      let chosenArr = localStoreageItem.split(',');
      chosenArr.push('id');
      const lower = chosenArr.map((element: any) => {
        return element?.toLowerCase();
      });
      loadReportPagination(1, lower, 'ReportsTable');
    } else {
      let chosenArr = [localStoreageItem];
      chosenArr.push('id');
      const lower = chosenArr.map((element) => {
        return element?.toLowerCase();
      });
      loadReportPagination(1, lower, 'ReportsTable');
    }
    if (userStore.user?.customerName === 'LVPCMS') {
      activityStore.searchListItemsLVPMSCount();
    }
    // loadTemplateMetaDataHeader();
    // eslint-disable-next-line
  }, []);

  const tableData: any[] = [];

  metaDataPaginationAll?.forEach((a) => {
    delete a?.isMaster;
    // eslint-disable-next-line
    delete a?.sections_Multiple_From;
    delete a?.sections_From;
    tableData?.push({
      ...a,
      movementdate: userReadableDateFormatMetaData(a.movementdate),
      movement_Time: userReadableDateFormatMetaData(a.movement_Time),
      maintenance: userReadableDateFormatMetaData(a.maintenance),
      receivingdate: userReadableDateFormatMetaData(a.receivingdate),
      status_Time: userReadableDateFormatMetaData(a.status_Time),
      itemCreatedAt: userReadableDateFormatMetaData(a.itemCreatedAt),
    });
  });

  const removeCol =
    'isdeleted,isActive,isReceiving,isDelivery,isReceivingOrder';
  const reportsTable = JSON.parse(JSON.stringify(tableData));
  reportsTable.map((i: any) => removeCol.split(',').map((j) => delete i[j]));

  const paginateFunction = (e: number) => {
    dashboardStore.dashboard.searchfilterparams[`current_task`] =
      currentTask.value;
    dashboardStore.dashboard.searchfilterparams[`current_subtask`] =
      currentSubTask.value;

    if (currentTask.value === '') {
      delete dashboardStore.dashboard.searchfilterparams[`current_task`];
    }
    if (currentSubTask.value === '') {
      delete dashboardStore.dashboard.searchfilterparams[`current_subtask`];
    }

    if (
      !_.isEmpty(dashboardStore.dashboard.searchfilterparams) &&
      Object.values(dashboardStore.dashboard.searchfilterparams).every(
        (o) => o !== '',
      ) &&
      dashboardStore.dashboard.orderData === '' &&
      dashboardStore.dashboard.orderName === ''
    ) {
      if (localStoreageItem?.split(',')) {
        let ReportTableChosenId = localStoreageItem?.split(',');
        ReportTableChosenId.push('id');
        const lower = ReportTableChosenId.map((element: any) => {
          return element?.toLowerCase();
        });
        reportStore.searchMetaDataReport(
          e,
          dashboardStore.dashboard.searchfilterparams,
          lower,
        );
      } else {
        let ReportTableChosenId = [localStoreageItem];
        ReportTableChosenId.push('id');
        const lower = ReportTableChosenId.map((element: any) => {
          return element?.toLowerCase();
        });
        reportStore.searchMetaDataReport(
          e,
          dashboardStore.dashboard.searchfilterparams,
          lower,
        );
      }
    } else if (
      dashboardStore.dashboard.orderData !== '' &&
      dashboardStore.dashboard.orderName !== ''
    ) {
      let chosenArr = localStoreageItem.split(',');
      chosenArr.push('id');
      reportStore.sortMetaDataReport(
        dashboardStore.dashboard.orderName,
        dashboardStore.dashboard.orderData,
        e,
        chosenArr!,
      ); //api call
      //   activityStore.sortListItems(dashboardStore.dashboard.orderName,dashboardStore.dashboard.orderData,e,5);//api call
    } else {
      let chosenArr = localStoreageItem.split(',');
      chosenArr.push('id');
      const lower = chosenArr.map((element: any) => {
        return element?.toLowerCase();
      });
      // let searchValues = dashboardStore.dashboard.searchfilterparams;
      if (DropdownParentAll === 'Parent') {
        reportStore.parentOptionApi(e, lower);
      } else {
        loadReportPagination(e, lower, 'ReportsTable');
      }
    }
    dashboardStore.setReportsPageNum(e);
    setPageNumber(e);
  };
  const searchFunction = (column: any, order: any) => {
    console.log(order, column);
  };

  return (
    <>
      {dashboardStore.dashboard.loadingdata !== 'loading' &&
        !commonStore.filterModeOne?.includes('RMDB01') && (
          <UnauthorizedMessage />
        )}
      {commonStore.filterModeOne.includes('RMDB01') && <></>}
      <div>
        {
          <DynamicTableComponentForMetaData
            key={uuid()}
            data={reportsTable}
            name={'ReportsTable'}
            actiontype={''}
            pageFunc={paginateFunction}
            pageNumData={pageNumber}
            searchFuncData={searchFunction}
            DropdownParentAll={DropdownParentAll}
            dropDowndata={dropDowndata}
          />
        }
      </div>
    </>
  );
}

export default observer(MetaDataReport2);
